const lib = {

  '测试': { en: "test" },
  '--测试--': {zh:"测试一条长内容",en:"test1..test2..test3..test4.." }

}

export default lib;


// WEBPACK FOOTER //
// ./lib/lang.js